import type { CharacterDef } from '../core/types';
import { portraitDataUrl } from '../render/portrait';
import './quips.css';

let current: HTMLElement | null = null;
let timer = 0;
let removeTimer = 0;

/** Egy rövid beszólás portréval, a verseny közben. Egyszerre csak egy látszik. */
export function showQuip(root: HTMLElement, character: CharacterDef, text: string): void {
  clearQuip();

  const el = document.createElement('div');
  el.className = 'quip';
  el.style.setProperty('--quip-accent', character.colors.accent);
  el.setAttribute('role', 'status');

  const portrait = document.createElement('img');
  portrait.className = 'quip__portrait';
  portrait.src = portraitDataUrl(character, 96);
  portrait.alt = '';
  portrait.width = 46;
  portrait.height = 46;

  const body = document.createElement('div');
  body.className = 'quip__body';
  const name = document.createElement('span');
  name.className = 'quip__name';
  name.textContent = character.short;
  const line = document.createElement('span');
  line.className = 'quip__text';
  line.textContent = text;
  body.append(name, line);

  el.append(portrait, body);
  root.appendChild(el);
  current = el;

  requestAnimationFrame(() => el.classList.add('is-in'));
  timer = window.setTimeout(() => {
    el.classList.add('is-out');
    removeTimer = window.setTimeout(() => {
      el.remove();
      if (current === el) current = null;
    }, 320);
  }, 3400);
}

export function clearQuip(): void {
  window.clearTimeout(timer);
  window.clearTimeout(removeTimer);
  current?.remove();
  current = null;
}
